<ng-template #content>
  <span class="close-modal-outside"><i (click)="dismiss.emit()" class="im-icon im-icon-x-light"></i></span>
  <div class="modal-wrap">
    @if (!ready) {
      <app-spinner [centerVertically]="true"></app-spinner>
    }
    @if (ready) {
      <div class="d-flex flex-grow-1">
        <div class="d-flex flex-column w-100 flex-grow-1 position-relative">
          <ng-content></ng-content>
        </div>
      </div>
    }
  </div>
</ng-template>

<!-- modal wrap -->
<div class="d-block detail-modal fade main-modal modal show modal--route">
  <div class="close-modal-area" (click)="dismiss.emit()"></div>
  <div class="modal-dialog">
    <div class="modal-content">

      <ng-container *ngTemplateOutlet="content"></ng-container>

    </div>
  </div>
</div>